import cloneDeep from 'lodash/cloneDeep';
import { Schema } from 'src/utils/form';
import { capitalizeFirstLetter } from 'src/utils/string';
import { TIPO_FILTRO_DATA } from 'src/utils/constants';

export const criarFiltroDefault = () => ({
  id: 0,
  matrizRisco: null,
  riscos: null,
  tipoFiltroData: { id: TIPO_FILTRO_DATA.ANO_ATUAL },
  dataInicio: null,
  dataTermino: null,
  responsaveis: null,
  areas: null,
  areasSubordinadas: false,
  tags: null,
  classificacoesRisco: null,
  tiposRisco: null,
  modelosRisco: null,
  tratamentos: null,
  statuses: null,
  causasRisco: null,
  consequenciasRisco: null,
  processos: null,
  subProcessos: false,
  indicadores: null,
  projetos: null,
  objetivos: null,
  categoriasDicionarioRisco: null,
  grauRiscoInerente: null,
  grauRiscoResidual: null,
  toleranciaRisco: null,
  toleranciaRiscoFaixas: null,
  camposCustomizados: [],
});

export const filtroSchema = Schema.object(
  Object.fromEntries(
    Object.keys(criarFiltroDefault()).map((field) => [
      field,
      field === 'id' ? Schema.any().showchip(false) : Schema.any().label(''),
    ])
  )
);

export const obterLabelsFiltro = (intl, resources) => {
  const format = (id, values) =>
    capitalizeFirstLetter(intl.formatMessage({ id }, values));

  return {
    matrizRisco: format('matrizRisco', { risco: resources.risco }),
    riscos: capitalizeFirstLetter(resources.riscos),
    tipoFiltroData: format('label.tipoFiltroData'),
    dataInicio: format('dataInicio'),
    dataTermino: format('dataTermino'),
    responsaveis: capitalizeFirstLetter(resources.responsaveis),
    areas: capitalizeFirstLetter(resources.area),
    areasSubordinadas: format('label.considerarAreasSubordinadas', {
      areas: resources.areas,
    }),
    tags: format('tags', { tags: resources.tags }),
    classificacoesRisco: format('label.classificacao'),
    tiposRisco: format('tipo'),
    modelosRisco: format('utilizarModelo', { risco: resources.risco }),
    tratamentos: format('tratamento'),
    statuses: format('status'),
    causasRisco: format('labelCausasDoRisco', {
      pontosproblematicos: resources.pontosproblematicos,
      risco: resources.risco,
    }),
    consequenciasRisco: format('labelConsequenciasDoRisco', {
      consequencias: resources.consequencias,
      risco: resources.risco,
    }),
    processos: format('label.itensImpactados'),
    subProcessos: format('incluirSubprocessos', {
      processosfilhosplural: resources.processosfilhosplural.toLowerCase(),
    }),
    indicadores: format('label.indicador', {
      indicador: resources.indicador,
    }),
    projetos: format('projeto', { projeto: resources.projeto }),
    objetivos: format('objetivoestrategico', {
      objetivoestrategico: resources.objetivoestrategico,
    }),
    categoriasDicionarioRisco: format('labelCategoriaDicionarioRisco', {
      riscos: resources.riscos,
    }),
    grauRiscoInerente: format('labelGrauRiscoInerente', {
      risco: resources.risco,
    }),
    grauRiscoResidual: format('labelGrauRiscoResidual', {
      risco: resources.risco,
    }),
    toleranciaRisco: format('labelToleranciaRisco', {
      risco: resources.risco,
    }),
    toleranciaRiscoFaixas: format('labelToleranciaRiscoFaixas', {
      risco: resources.risco,
    }),
  };
};

export const normalizarFiltro = (filtro, periodos = [], matrizDefault) => {
  const result = { ...criarFiltroDefault(), ...filtro };
  result.matrizRisco = result.matrizRisco?.id
    ? result.matrizRisco
    : matrizDefault || null;
  const tipoFiltroData = result.tipoFiltroData || {
    id: TIPO_FILTRO_DATA.ANO_ATUAL,
  };
  result.tipoFiltroData =
    periodos.find((periodo) => periodo.id === tipoFiltroData.id) ||
    tipoFiltroData;

  if (result.tipoFiltroData.id !== TIPO_FILTRO_DATA.PERIODO) {
    result.dataInicio = null;
    result.dataTermino = null;
  }

  return result;
};

export const mesclarCamposCustomizados = (definicoes, selecionados = []) =>
  cloneDeep(definicoes || []).map((campo) => {
    const selecionado = selecionados?.find(
      (item) =>
        (item.idCampo ?? item.campo?.id) === (campo.idCampo ?? campo.campo?.id)
    );
    campo.valor = selecionado?.valor ?? null;
    campo.campo.valores = cloneDeep(selecionado?.campo?.valores ?? null);
    return campo;
  });

export const limparCamposCustomizados = (campos = []) =>
  cloneDeep(campos || []).map((campo) => ({
    ...campo,
    valor: null,
    campo: { ...campo.campo, valores: null },
  }));

export const prepararFiltroParaSalvar = (filtro) => ({
  ...filtro,
  camposCustomizados: (filtro.camposCustomizados || []).map((campo) => ({
    idCampo: campo.idCampo ?? campo.campo?.id,
    valor: cloneDeep(campo.valor ?? null),
    campo: { valores: cloneDeep(campo.campo?.valores ?? null) },
  })),
});
